module.exports = __webpack_public_path__ + "static/media/pip.039f0922.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereby/pip.jpg
// module id = 340
// module chunks = 0